import { graphql } from '@repo/common/queries/schemas/server_user_query'

export const query_list_redeemables = graphql(`
  query list_redeemables {
    redeemables {
      id
      name
      symbol
      paused
      published
      settlement_balance
      rate_adjustment

      commission_fee_info {
        current_unliquidated_total
        days_until_next_redemption
        total_aum
        fee_schedule {
          boundary_percentages: boundaries
          entries {
            days_until
            fee_percentages
          }
        }
      }

      networks {
        network

        deposit_token {
          address
          symbol
          decimals
        }

        settlement_token {
          address
          symbol
          decimals
        }
      }

      price_feed_protocol
      price_feed {
        address
        network
      }
    }
  }
`)

export const query_list_redeemables_commission_fees = graphql(`
  query list_redeemables_commission_fees {
    redeemables {
      id
      paused
      settlement_balance

      commission_fee_info {
        current_unliquidated_total
        total_aum
        days_until_next_redemption
        fee_schedule {
          boundary_percentages: boundaries
          entries {
            days_until
            fee_percentages
          }
        }
      }
    }
  }
`)

export const query_redemptions = graphql(`
  query redemptions($wallet_address: CryptoAddress!) {
    redemptions(wallet_address: $wallet_address, first: 100) {
      nodes {
        id
        redeemable_id
        status
        error_reason: error
        deposit_confirmed_at
        settled_at

        deposit_total
        fees_total
        settlement_total

        redeemable_network {
          network
          deposit_token {
            symbol
          }
          settlement_token {
            symbol
          }
        }

        settlement_transaction {
          tx_hash
        }
      }
    }
  }
`)

export const mutation_start_redemption = graphql(`
  mutation start_redemption($input: StartRedemptionInput!) {
    start_redemption(input: $input) {
      deposit_address
      paused
      redemption {
        id
        network
        status
      }
    }
  }
`)
